import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import history from "../history";



function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
  
    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);
  
    const showButton = () => {
      if (window.innerWidth <= 960) {
        setButton(false);
      } else {
        setButton(true);
      }
    };
  
    // useEffect(() => {
    //   showButton();
    // }, []);
  
    window.addEventListener('resize', showButton);
  

    return (
        <>
          <nav className='navbar'>
            <div className='navbar-container'>
              <Link to='/~krempaska21/' className='navbar-logo' 
              onClick = {() => history.push('/~krempaska21/plan'),closeMobileMenu }>
                <img
                className='fa-typo3'
                alt='Logo'
                src={'./images/tonIkLogo.png'}
            />

              </Link>
              <div className='menu-icon' onClick={handleClick}>
                <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
              </div>
              <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                <li className='nav-item'>
                  <Link to='/~krempaska21/' className='nav-links' 
                  onClick = {() => history.push('/~krempaska21/'),closeMobileMenu }>
                    Domov
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    to='/~krempaska21/plan'
                    className='nav-links'
                    onClick = {() => history.push('/~krempaska21/plan'),closeMobileMenu }
                  >
                    Plán
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    to='/~krempaska21/zdroje'
                    className='nav-links'
                    onClick = {() => history.push('/~krempaska21/zdroje'),closeMobileMenu }
                  >
                    Zdroje
                  </Link>
                </li>

                <li className='nav-item'>
                  <Link
                    to='/~krempaska21/downloads'
                    className='nav-links'
                    onClick = {() => history.push('/~krempaska21/downloads'),closeMobileMenu }
                  >
                   Download
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </>
      );

}

export default Navbar;